import { Text } from "components/shared/text";
import { FC } from "react";
import { formatPrice } from "utils/helpers";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

export const SolutionSummaryItem: FC<{
  title: string;
  image?: string;
  price: number;
  isTotal?: boolean;
  name: string;
}> = ({ title, name, isTotal, image, price }) => {
  const { t } = useTranslation();
  const { network } = useSalesNetwork();
  const defaultBrand =
    network && network.brands && network.brands.length > 0
      ? network.brands[0].brand
      : null;

  return (
    <group
      data-direction="column"
      data-align="center"
      data-gap="4"
      data-space-vertical="8"
      data-space-horizontal="16"
      data-length="260"
      data-border=""
    >
      <group>
        <Text data-weight="400" data-color="grey-color-mid" data-text-size="14">
          {title}
        </Text>
      </group>
      <group
        data-length="230"
        data-space="4"
        data-gap="4"
        data-radius="5"
        data-wrap="no"
        data-height="auto"
        {...(isTotal
          ? defaultBrand && defaultBrand === "ATLANTIC"
            ? { "data-background": "success-color-light" }
            : { "data-background": "main" }
          : { "data-background": "accent-xtralight" })}
      >
        {image && (
          <group
            data-shrink="no"
            data-radius="5"
            data-length="50"
            data-ratio="1:1"
          >
            <picture>
              <img src={image} alt="" />
            </picture>
          </group>
        )}
        <group
          data-direction="column"
          data-length="autofit"
          data-justify="center"
          data-color="grey-color-dark"
          data-space-horizontal="12"
        >
          <group data-gap="5" data-radius-bottom="10" data-length="160">
            <Text
              data-weight="400"
              data-text-size="12"
              data-uppercase=""
              data-wrap="wrap"
              data-spacing="0.5"
              {...(defaultBrand && defaultBrand === "ACV" && isTotal
                ? { "data-color": "white" }
                : {})}
            >
              {name}
            </Text>
          </group>
          {network?.showPrice && (
            <group data-name="cost" data-align="center" data-text-size="16">
              <text
                data-text-size="medium"
                {...(defaultBrand && defaultBrand === "ACV" && isTotal
                  ? { "data-color": "white" }
                  : {})}
              >
                {formatPrice(price)} {t("FO_SOL_CURRENCY")}
              </text>
            </group>
          )}
        </group>
      </group>
    </group>
  );
};
